import { BsCheckLg } from "react-icons/bs";
import { generateIcon } from "utils";

interface ISummaryBageProps {
  title: string;
  className: string;
}

export function SummaryBadge({ title, className }: ISummaryBageProps) {
  return (
    <div className={`relative pt-1 pr-1 inline-flex items-center ${className}`}>
      <div className="bg-[#C1FF72] rounded-full w-9 h-9 flex items-center justify-center relative border-8 border-[#7ED957] z-10">
        {generateIcon(BsCheckLg, "text-black text-[18px] stroke-2")}
      </div>
      <div className="bg-[#C1FF72] font-bold uppercase rounded-2xl w-38 h-6 pl-9 pr-1 flex items-center justify-center -ml-8 relative z-0">
        <span className="text-black text-[10px]">{title}</span>
      </div>
    </div>
  );
}
